import { render, staticRenderFns } from "./LOGIN.vue?vue&type=template&id=4cfae4dc&scoped=true"
import script from "./LOGIN.vue?vue&type=script&lang=js"
export * from "./LOGIN.vue?vue&type=script&lang=js"
import style0 from "./LOGIN.vue?vue&type=style&index=0&id=4cfae4dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfae4dc",
  null
  
)

export default component.exports